export default "dist/images/block-header-basic.ebc668b.png";